import React from 'react'
import '../assets/scss/main.scss'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Main from '../components/Main'
import Footer from '../components/Footer'

import highresBg from '../images/bg.jpg'

class Template extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isArticleVisible: false,
      timeout: false,
      articleTimeout: false,
      article: '',
      loading: 'is-loading',
      altBg: null
    }

    this.onHashChange = this.onHashChange.bind(this)
    this.handleOpenArticle = this.handleOpenArticle.bind(this)
    this.handleCloseArticle = this.handleCloseArticle.bind(this)
    this.handleChangeArticle = this.handleChangeArticle.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)
  }

  handleBodyClick () {
    if (this.state.isArticleVisible) {
      document.location.hash = ''
    }
  }

  componentDidMount () {
    this.timeoutId = setTimeout(() => {
        this.setState({loading: ''});
    }, 100);

    this.secondTimeoutId = setTimeout(() => {
      if (document.location.hash) {
        this.handleOpenArticle(document.location.hash.replace(/^#/, ''));
      }
    }, 1000);

    window.addEventListener('hashchange', this.onHashChange);

    const img = new Image();
    img.onload = () => {
      console.log(img.src)
      this.setState({altBg: img.src})
    }
    img.src = highresBg;
  }

  componentWillUnmount () {
    if (this.timeoutId) {
        clearTimeout(this.timeoutId);
    }
    if (this.secondTimeoutId) {
        clearTimeout(this.secondTimeoutId);
    }

    window.removeEventListener('hashchange', this.onHashChange);
  }

  onHashChange() {
    const hash = document.location.hash.replace(/^#/, '');
    if (hash) {
      this.handleChangeArticle(hash);
    } else {
      this.handleCloseArticle();
    }
  }

  handleOpenArticle(article) {
    this.setState({
      isArticleVisible: !this.state.isArticleVisible,
      article
    }, () => {
      // document.location.hash = article;
    })

    setTimeout(() => {
      this.setState({
        timeout: !this.state.timeout
      })
    }, 325)

    setTimeout(() => {
      this.setState({
        articleTimeout: !this.state.articleTimeout
      })
    }, 350)

  }

  handleCloseArticle(callback) {
    if (this.state.isArticleVisible) {
      this.setState({
        articleTimeout: !this.state.articleTimeout
      })

      setTimeout(() => {
        this.setState({
          timeout: !this.state.timeout
        })
      }, 325)

      setTimeout(() => {
        this.setState({
          isArticleVisible: !this.state.isArticleVisible,
          article: ''
        }, () => {
          // document.location.hash = "";
          if (callback) {
            callback()
          }
        })
      }, 350)
    } else if (callback) {
      callback();
    }

  }

  handleChangeArticle(newArticle) {
    this.handleCloseArticle(() => {
      this.handleOpenArticle(newArticle);
    });
  }

  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const { location, children } = this.props

    let rootPath = `/`

    let content;

    if (location.pathname === rootPath) {
      content = (
        <div id="wrapper">
          <Header onOpenArticle={this.handleOpenArticle} timeout={this.state.timeout} />
          <Main
            isArticleVisible={this.state.isArticleVisible}
            timeout={this.state.timeout}
            articleTimeout={this.state.articleTimeout}
            article={this.state.article}
            onCloseArticle={this.handleCloseArticle}
            onChangeArticle={this.handleChangeArticle}
          />
          <Footer timeout={this.state.timeout} />
        </div>
      )
    } else {
      content = (
        <div id="wrapper" className="page">
          <div style={{
            maxWidth: '1140px'
          }}>
            {children()}
          </div>
        </div>
      )
    }

    let bg = <div id="bg"></div>;
    if (this.state.altBg) {
      bg = <div id="bg" style={{backgroundImage: `url(${this.state.altBg})`}} />
    }

    return (
      <div className={`body ${this.state.loading} ${this.state.isArticleVisible ? 'is-article-visible' : ''}`} onClick={this.handleBodyClick}>
        <Helmet>
            <title>{siteTitle}</title>
            <meta name="google-site-verification" content="qKuWqJYjwRXFSJzH5uoPqjjdFrBWflbZq-7HOWv31JE" />
            <meta name="description" content={siteDescription} />
            <meta name="google-site-verification" content="u2OqGPw3zuIlM329WnNL5kDWkwF--xOfZHpFvpIBK9g" />
        </Helmet>

        {content}

        {bg}
      </div>
    )
  }
}

export default Template

export const pageQuery = graphql`
  query PageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js